// Google AdSense Auto-ads loader.
// Injects pagead2/adsbygoogle.js only when the shared eligibility helper says
// the visitor should see ads. Consent Mode v2 updated per "essential" vs "all".
import { useEffect, useRef } from 'react';
import { useAdsEligibility } from '@/lib/adsEligibility';

const SCRIPT_ID = 'adsense-auto-ads';
const ADSENSE_SRC = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

export function applyAdConsent(choice) {
  const granted = choice === 'all';
  const state = granted ? 'granted' : 'denied';
  try {
    window.gtag?.('consent', 'update', {
      ad_storage: state,
      ad_user_data: state,
      ad_personalization: state,
    });
  } catch { /* noop */ }
  try {
    window.adsbygoogle = window.adsbygoogle || [];
    window.adsbygoogle.requestNonPersonalizedAds = granted ? 0 : 1;
  } catch { /* noop */ }
}

export default function AdSenseLoader() {
  const { publisherId, consent, enabled } = useAdsEligibility();
  const loadedFor = useRef(null);

  useEffect(() => {
    if (!enabled || !consent) return;

    if (loadedFor.current === null) {
      const granted = consent === 'all';
      try {
        window.adsbygoogle = window.adsbygoogle || [];
        window.adsbygoogle.pauseAdRequests = 1;
        window.adsbygoogle.requestNonPersonalizedAds = granted ? 0 : 1;
      } catch { /* noop */ }

      applyAdConsent(consent);

      let script = document.getElementById(SCRIPT_ID);
      if (!script) {
        script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.src = `${ADSENSE_SRC}?client=${encodeURIComponent(publisherId)}`;
        document.head.appendChild(script);
      }
      const resume = () => {
        try {
          window.adsbygoogle.pauseAdRequests = 0;
          window.adsbygoogle.push({});
        } catch { /* noop */ }
      };
      script.addEventListener('load', resume, { once: true });
      loadedFor.current = consent;
    } else if (loadedFor.current !== consent) {
      applyAdConsent(consent);
      loadedFor.current = consent;
    }
  }, [enabled, publisherId, consent]);

  return null;
}
